module.exports = __webpack_public_path__ + "static/img/1.212dcb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fan/1.png
// module id = TkSX
// module chunks = 1